import ContentLogs from './ContentLogs';

const RivalContentLogs = () => (
  <ContentLogs
    accountType="rival"
    content="查看竞品作品7日内的监测数据，作为竞品作品效果的基础数据查询工具。"
    showAccountColumn
    title="竞品作品"
  />
);

export default RivalContentLogs;
